import { usePerms } from '@xstudios/xapp-auth/composables/usePerms'

function apply(el, binding) {
  const { perm } = usePerms()
  el.style.display = perm(binding.value) ? '' : 'none'
}

export default { mounted: apply, updated: apply }
